module.exports = __webpack_public_path__ + "media/images/icon-notice-new-cc23d16c3582aca9aa040c2a3fab95a7.svg";